var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17396",
    transform: "translate(216.5 313)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216.5 -313)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17395",
    fill: "none",
    d: "M216.5 313h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21627",
    d: "M244 315.875h-.312l-7.5 2h-.625l-8.125-2.25h-.625l-8.125 2.125a1.188 1.188 0 0 0-.938 1.187v19.938a1.25 1.25 0 0 0 1.25 1.25h.313l7.5-2h.625l8.125 2.25h.625l8.125-2.187a1.187 1.187 0 0 0 .938-1.125v-19.938a1.25 1.25 0 0 0-1.251-1.25Zm-15.625 2.563 6.25 1.813v17.312l-6.25-1.812Zm-8.125 1.5 5.625-1.5v17.312l-5.625 1.5Zm22.5 16.125-5.625 1.5V320.25l5.625-1.5Z",
    fill: "#185edf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapChartBlue);
export default __webpack_public_path__ + "static/media/map-chart-blue.1499dea1dbd8e2a66d6aee71d0d6681b.svg";
export { ForwardRef as ReactComponent };